<div class="star-rating">
    <span class="me-1" *ngFor="let _ of [].constructor(5); let i = index" (click)="rateStar(i)"
        (mouseover)="onStarHover(i)" (mouseout)="onStarLeave()" [class.selected]="i < rating"
        [class.hovered]="i <= hoveredIndex" [class.selected]="i < rating">&#9733;</span>
</div>